import type { ProductColor } from '../../__generated__/graphql/catalog/graphql'

type LikeColorGroup = { colors: Pick<ProductColor, 'rawName'>[] }

/* Check if a given color key exists as an option in any of the provided color groups. */
export function existsInColorGroups<T extends LikeColorGroup>(
  colorKey: string,
  ...colorGroups: T[]
): boolean {
  return colorGroups.some(colorGroup => colorGroup.colors.some(color => color.rawName === colorKey))
}

/* This can be used to convert an opacity value between 0 and 1 into a hexString for CSS usage. */
export const floatToTwoDigitHex = (floatVal: number): string => {
  if (floatVal < 0.0 || floatVal > 1.0 || isNaN(floatVal)) {
    throw new Error('Input float must be between 0.0 and 1.0')
  }
  const scaledInt = Math.round(floatVal * 255)
  const hexRepresentation = scaledInt.toString(16).padStart(2, '0')
  return hexRepresentation
}
